import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { useAccordionContext } from '@ver-uds/uswds-react';
import Header, { HeaderProps } from './Header';
import CheckboxHeader, { CheckboxHeaderProps } from './CheckboxHeader';
import Body, { BodyProps } from './Body';
import MoreDetails, { MoreDetailsProps } from './MoreDetails';
import RadioHeader, { RadioHeaderProps } from './RadioHeader';

export interface AccordionCardProps {
  children: [
    ReactElement<HeaderProps> | ReactElement<CheckboxHeaderProps> | ReactElement<RadioHeaderProps>,
    ReactElement<BodyProps>,
    ReactElement<MoreDetailsProps>,
  ];
  className?: string;
  id?: string;
  /**
   * The Accordion Card Body's id that this button controls
   */
  controls: string;
}

const AccordionCard = ({ children, className, id, controls }: AccordionCardProps): JSX.Element => {
  const { toggle, isOpen } = useAccordionContext();
  const handleClick = (): void => toggle(controls);
  const expanded = isOpen(controls);

  return (
    <li
      id={id}
      className={classNames('ver-accordion-card usa-card', { 'ver-accordion-card--expanded': expanded }, className)}
    >
      <div className="ver-accordion-card__container usa-card__container">
        <div className="ver-accordion-card__content">{children}</div>
        <button
          type="button"
          className="ver-accordion-card__button"
          aria-label={expanded ? `Collapse card ${controls}` : `Expand card ${controls}`}
          aria-expanded={expanded}
          aria-controls={controls}
          onClick={handleClick}
        />
      </div>
    </li>
  );
};

AccordionCard.Header = Header;
AccordionCard.CheckboxHeader = CheckboxHeader;
AccordionCard.RadioHeader = RadioHeader;
AccordionCard.Body = Body;
AccordionCard.MoreDetails = MoreDetails;

export default AccordionCard;
